import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { currentDeploymentSelector } from "Reducers/environment/deployment";

import { securePath, sortRoutes } from "../util";

type Props = {
  organizationId: string;
  projectId: string;
  environmentId: string;
  hideRedirects?: boolean;
  routeMaxNumber: number;
};
export const useEnvironmentRoutes = ({
  organizationId,
  projectId,
  environmentId,
  hideRedirects,
  routeMaxNumber
}: Props) => {
  const environment = useSelectorWithUrlParams(environmentSelector, {
    organizationId,
    projectId,
    environmentId
  });

  const deploymentCurrent = useSelectorWithUrlParams(
    currentDeploymentSelector,
    {
      organizationId,
      projectId,
      environmentId
    }
  );

  const deploymentRoutes = Object.entries(deploymentCurrent?.routes ?? {})
    .filter(([, a]) => a.type !== "redirect")
    .map(([key]) => key);

  let environmentRoutes: string[] = [];
  if (typeof environment?.getRouteUrls === "function") {
    environmentRoutes = environment.getRouteUrls();
  }

  const routes = hideRedirects ? deploymentRoutes : environmentRoutes;

  const { httpsList, httpList } = routes.reduce<{
    httpsList: string[];
    httpList: string[];
  }>(
    (urls, url) => {
      if (url.includes("*")) return urls;
      if (securePath(url)) {
        urls.httpsList.push(url);
        return urls;
      }
      urls.httpList.push(url);
      return urls;
    },
    { httpsList: [], httpList: [] }
  );

  const routeList = httpsList
    .sort(sortRoutes)
    .concat(httpList.sort(sortRoutes));

  const slicedRouteList = routeList.slice(0, routeMaxNumber);

  return {
    routeList,
    slicedRouteList
  };
};
